module.exports = __webpack_public_path__ + "img/archive-done.77046ef1.svg";